import { useFormat } from 'vivat';
import useDelivery from '@/useDelivery';

const { shipmentStatusClassMap, translate } = useDelivery();

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    _selectorControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    code: {
      name: 'เลขที่ใบวางบิล',
      width: '8rem',
      class: {
        text: 'text-center',
        cell: 'text-center',
      },
    },
    createdAt: {
      name: 'วันที่สร้างบิล',
      width: '10rem',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item?.invoice?.createdAt ? useFormat.date(row.item.invoice.createdAt).displayShortThaiDateTime() : '',
      class: 'text-center',
    },
    deliveryNote: {
      name: 'เลขที่ใบจัดรถ',
      width: '9rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: any, row: any) =>  val?.uniqueId ? val.uniqueId : '',
    },
    orderNumber: {
      name: 'เลขที่ใบส่งสินค้า',
      width: '10rem',
      class: 'text-center',
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return shipmentStatusClassMap(val);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val);
      },
    },
    senderCode: {
      name: 'รหัสผู้ส่ง',
      width: '8rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    senderName: {
      name: 'ชื่อผู้ส่ง',
      width: '16rem',
      // eslint-disable-next-line
      filter: (val: string) => val !== 'NA' ? val : '',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    customerCode: {
      name: 'รหัสผู้รับ',
      width: '8rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    customerName: {
      name: 'ชื่อผู้รับ',
      width: '16rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    path: {
      name: 'เส้นทางจัดส่ง',
      width: '16rem',
    },
    totalWeight: {
      name: 'น้ำหนัก (กก.)',
      width: '8rem',
      filter(val: string) {
        return parseFloat(parseFloat(val).toFixed(3));
      },
      class: 'text-right',
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '8rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    createdBy: {
      name: 'ผู้สร้างรายการ',
      width: '10rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: any, row: any) =>  row.item.invoice && row.item.invoice.createdBy ? row.item.invoice.createdBy?.name : '',
    },
  },
  sortable: [
    'createdAt',
    // 'deliveryNote.uniqueId',
    'orderNumber',
    'status',
    'customerName',
    'totalWeight',
    'deliveryFee',
    'createdBy',
  ],
};
